
const DefaultStore = {
    
}

export default DefaultStore